exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-text[data-v-0df9df8c]{background-color:#f8f9fa;border-color:#ced4da}", ""]);

// exports
